import { render, staticRenderFns } from "./DatabaseComponent.vue?vue&type=template&id=3f9194cf"
import script from "./DatabaseComponent.vue?vue&type=script&lang=js"
export * from "./DatabaseComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports